import { Button, Icon } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div<{ $height: string }>`
  height: ${({ $height }) => $height};
  overflow: hidden;
  transition: height 0.3s;
  margin-bottom: 0 !important;
`

const Trigger = styled(Button)`
  position: relative;

  &:before {
    content: '';
    width: 100%;
    height: 30px;
    position: absolute;
    top: -24px;
    z-index: 1;
    background-image: linear-gradient(0deg, #fff 30%, hsla(0, 0%, 100%, 0));
  }
`

interface CollapseByHeightProps {
  closeText: string
  openText: string
  height: string
  onClick: (result: string) => void
}

export function CollapseByHeight({
  closeText,
  openText,
  height,
  onClick,
  children,
}: React.PropsWithChildren<CollapseByHeightProps>) {
  const [isOpen, setIsOpen] = React.useState(false)
  const [currentHeight, setCurrentHeight] = React.useState(height)

  const handleOnToggle = () => {
    setIsOpen(!isOpen)
    if (isOpen) {
      setCurrentHeight(height)
      onClick('Show less')
    }
    else {
      setCurrentHeight('100%')
      onClick('Show more')
    }
  }

  return (
    <>
      <Wrapper $height={currentHeight}>{children}</Wrapper>
      <Trigger $type="transparentPrimary" onClick={handleOnToggle}>
        {isOpen ? openText : closeText}
        <Icon glyph={isOpen ? 'ChevronUpExtraSmall' : 'ChevronDownExtraSmall'} />
      </Trigger>
    </>
  )
}
